import { push } from 'react-router-redux';
import { select, put } from 'redux-saga/effects';

import graphqlClient from '../consumers/graphqlClient';
import UpdateProductMutation from '../graphql/mutations/UpdateProduct';
import ProductsQuery from '../graphql/queries/ProductsQuery';
import selectWorkspaceProducerId from '../selectors/workspaceProducerId';

export default function* deleteProductSaga(action) {
  const workspaceProducerId = yield select(selectWorkspaceProducerId);

  try {
    yield graphqlClient.mutate({
      mutation: UpdateProductMutation,
      variables: {
        id: action.payload,
        productPatch: {
          visibility: false,
        },
      },
      refetchQueries: [
        {
          query: ProductsQuery,
          variables: {
            first: 25,
            condition: {
              producerId: workspaceProducerId,
              visibility: true,
            },
          },
        },
      ],
    });

    yield put(push('/products'));
  } catch (e) {
    console.log(e);
  }
}
